export default "__VITE_ASSET__Bb8DgIzN__"